import React, { createContext, useState, useContext  } from 'react';
import { APIContext } from '../../../../context/';
import {  Button } from '@material-ui/core';
import CustomToolbar from '../../../customToolbar';
import SectorDialogForm from '../../../forms/sectorForm';
import AddIcon from "@material-ui/icons/Add";

export const SectoresContext = createContext();

const SectoresProvider = (props) => {

    const ruta_existe = `precalificacion/search?sect_id`;

    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({
        sect_nombre: "",
        sect_estado: "",
    });

    const [editableObject, seteditableObject] = useState({});
    const [dialogOpen, setDialogOpen] = useState(false);
    const { sectores,
        unCheck,verificar_borrar,deleteSector,
    } = useContext(APIContext);

    const headCells = [
        // Toma, tipo, pasajeros, cilindrada, combustible
        { id: 'sect_id', numeric: true, disablePadding: false, label: '#' },
        { id: 'sect_nombre', numeric: false, disablePadding: false, label: 'Nombre' },
        { id: 'sect_estado_nom', numeric: true, disablePadding: false, label: 'Estado' },

    ];

    const idName = "sect_id";

    const data = sectores

    const estado = [
        { value: 1, tipo: "Activo" },
        { value: 2, tipo: "Inactivo" },
    ]

    const columns = [
        //{ name: 'id', label: '#' },
        { name: 'sect_nombre', label: 'Nombre' },
        { name: 'sect_estado_nom', label: 'Estado' },
        {
          name: "",
          options: {
    
            filter: false,
            sort: false,
            empty: true,
            customBodyRenderLite: (dataIndex) => {
              const data = sectores[dataIndex];
    
              return (
                <>
    
                  <Button variant="outlined" color="primary"
                    onClick={(e) => {
                      seteditableObject(data);
                      handleDialogOpen();
                    }}>
                    Ver
                  </Button>
    
                </>
              );
            }
          }
        }
    
    ];
     
    const options = {
        filter: true,
        filterType: "multiselect",
        textLabels: {
          body: {
            noMatch: "Sorry, no matching records found",
            toolTip: "Sort",
            columnHeaderTooltip: column => `Sort for ${column.label}`
          },
          pagination: {
            next: "Siguiente",
            previous: "Anterior",
            rowsPerPage: "Registros por página:",
            displayRows: "de",
          },
          toolbar: {
            search: "Buscar",
            downloadCsv: "Descargar CSV",
            print: "Imprimir",
            viewColumns: "ver Columnas",
            filterTable: "Filtrar Tabla",
          },
          filter: {
            all: "TODOS",
            title: "FILTROS",
            reset: "RESTABLECER",
          },
          viewColumns: {
            title: "Mostrar Columnas",
            titleAria: "Mostrar/Ocultar Columnas",
          },
          selectedRows: {
            text: "Registro(s) seleccionados",
            delete: "Eliminar",
            deleteAria: "Eliminar Registro(s) seleccionados",
          },
        },
        onRowsDelete:(rowsDeleted) => {
            const array = rowsDeleted.data
            const DeleteId = array.map((arr,index)=>{
                return sectores[arr.dataIndex].sect_id
            })

            array.map((arr,index)=>{
                let id     = sectores[arr.dataIndex].sect_id
                let nombre = sectores[arr.dataIndex].sect_nombre
               
                verificar_borrar(ruta_existe, id, nombre, DeleteId)
                .then(function(result) {
                    if(result){
                        deleteSector(id, nombre, DeleteId); 
                    }
                });
               
                return arr
            })
            unCheck();
            return false
        },
        customToolbar: () => {
          return (
            <CustomToolbar Component={SectorDialogForm} CustomIcon={AddIcon} />
          );
        },
    }

    const handleDialogOpen = () => {
        setDialogOpen(true);
      };
      const handleDialogClose = () => {
        setDialogOpen(false)
      }

    const clearForm = () => {
        setForm({
            sect_nombre: "",
            sect_estado: "",
        })
    }

    return (
        <SectoresContext.Provider
            value={{
                form,
                open,
                headCells,
                idName,
                columns,
                options,
                data,
                dialogOpen,
                editableObject,
                estado,

                clearForm,
                setOpen,
                handleDialogOpen,
                handleDialogClose,
            }}
        >
            {props.children}
        </SectoresContext.Provider>
    );
}

export default SectoresProvider;